/**
 * MPCI module-wide constants.
 *
 * MPCI_ADMIN_ORG_ID — the special "super-admin" party ID that can see
 * ALL organisations' data. Every other orgId sees only its own records.
 */
export const MPCI_ADMIN_ORG_ID = 59
